import { Image, MantineRadius, Popover } from '@mantine/core';
import React from 'react';
import { getSharepointCdnFileMedia } from '../../../utilities';

interface TableImageProps {
  imageUrl: string;
  w?: number | string;
  h?: number | string;
  radius?: MantineRadius;
}

const TableImage: React.FC<TableImageProps> = ({
  imageUrl,
  w = 100,
  h = 'auto',
  radius = 'sm'
}) => {
  const urlImage = imageUrl ? getSharepointCdnFileMedia(imageUrl) : ''
  return (
    <Popover key={imageUrl} width={600} position="bottom" withArrow shadow="md">
      <Popover.Target>
        <Image
          src={urlImage}
          w={w}
          h={h}
          radius={radius}
          style={{ cursor: 'pointer' }}
        />
      </Popover.Target>

      <Popover.Dropdown>
        <Image src={urlImage} width={300} height={'auto'} />
      </Popover.Dropdown>
    </Popover>
  );
};

export default TableImage;
